export const blockIconsHardwareKeyboardDoubleArrowRight = (
	<span className='material-symbols-outlined'>keyboard_double_arrow_right</span>
);
